function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.797 9.33l-1.899 1.9H7.399v12.346h12.346l-.001-7.45 1.899-1.899v9.349a1.9 1.9 0 01-1.898 1.899H7.399a1.9 1.9 0 01-1.899-1.9V11.23a1.9 1.9 0 011.9-1.899h8.397zm4.514-1.827l2.686 2.686-9.898 9.898a1 1 0 01-.763.291l-1.651-.091a.5.5 0 01-.472-.472l-.091-1.651a1 1 0 01.291-.763l9.898-9.898zm3.603-2.19l1.272 1.273a1 1 0 010 1.414L23.88 9.307l-2.686-2.686L22.5 5.314a1 1 0 011.414 0z",
  fill: "#0592AF",
  fillRule: "evenodd"
});

function SvgManualScoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30
  }, props), _ref);
}

export default SvgManualScoreIcon;